import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/** The first resource the overlay can open. An image, not an activity. */
export const SAMPLE_GIF_URL =
  'https://media1.tenor.com/m/3sWbsPtf6k0AAAAd/mommy-dance-dancing-grandma.gif';

@Component({
  selector: 'app-resource-overlay',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'absolute top-4 left-4 z-10 flex w-80 max-h-[calc(100%-2rem)] flex-col gap-3 overflow-auto rounded-lg bg-[var(--mat-sys-surface)] p-4 shadow-lg',
    role: 'region',
    '[attr.aria-label]': 'title()',
    '(keydown.escape)': 'closed.emit()',
  },
  template: `
    <img class="max-h-[70vh] max-w-full" [src]="src()" [alt]="alt()" />
    <button
      type="button"
      class="w-fit rounded-full px-4 py-2 text-sm font-semibold hover:bg-[var(--mat-sys-on-surface)]/10"
      (click)="closed.emit()"
    >
      {{ closeLabel() }}
    </button>
  `,
})
export class ResourceOverlayComponent {
  readonly src = input.required<string>();
  readonly title = input.required<string>();
  readonly alt = input.required<string>();
  readonly closeLabel = input.required<string>();
  readonly closed = output<void>();
}
